import React, { useState } from "react";
import "./style.css";
import Sidebar from "../Navigation/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../assests/leftArrow.svg";

const ScreensaversComp = ({ isLoading = false }) => {
  const navigate = useNavigate();

  const arrowClick = () => {
    navigate("/");
  };

  return (
    <>
      {isLoading ? (
        <div className="screensaver-loading-container">
          <div className="screensaver-loading-spinner"></div>
          <p className="screensaver-loading-text">Loading Screensavers...</p>
        </div>
      ) : (
        <div className="screensaver-main-container">
          <Sidebar />

          <div className="screensaver-content-wrapper">
            {/* Header Section */}
            <div className="screensaver-header">
              <img
                onClick={arrowClick}
                className="screensaver-back-icon"
                src={leftArrow}
                alt="Back"
              />
              <p className="screensaver-title">Screensavers</p>
            </div>

            {/* Coming Soon Card */}
            <div className="screensaver-coming-soon-container">
              <div className="screensaver-coming-soon-card">
                <div className="screensaver-coming-soon-icon-wrapper">
                  <svg 
                    className="screensaver-coming-soon-icon"
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="1.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="8" y1="21" x2="16" y2="21"></line>
                    <line x1="12" y1="17" x2="12" y2="21"></line>
                    <path d="M4 3h16"></path>
                    <circle cx="9" cy="10" r="1.5"></circle>
                    <circle cx="15" cy="10" r="1.5"></circle>
                    <path d="M8 14h8"></path>
                  </svg>
                </div>
                <h2 className="screensaver-coming-soon-heading">
                  Screensavers Gallery
                </h2>
                <p className="screensaver-coming-soon-subtext">
                  Coming Soon!
                </p>
                <p className="screensaver-coming-soon-description">
                  Get ready to customize your displays with our collection of engaging screensavers. 
                  We're creating beautiful, dynamic screensavers that will enhance customer experience.
                </p>
                <div className="screensaver-coming-soon-features">
                  <div className="screensaver-feature-item">
                    <span className="screensaver-feature-dot"></span>
                    <span>HD Screensavers</span>
                  </div>
                  <div className="screensaver-feature-item">
                    <span className="screensaver-feature-dot"></span>
                    <span>Brand Templates</span>
                  </div>
                  <div className="screensaver-feature-item">
                    <span className="screensaver-feature-dot"></span>
                    <span>Custom Uploads</span>
                  </div>
                  <div className="screensaver-feature-item">
                    <span className="screensaver-feature-dot"></span>
                    <span>Scheduling Options</span>
                  </div>
                  <div className="screensaver-feature-item">
                    <span className="screensaver-feature-dot"></span>
                    <span>Preview Mode</span>
                  </div>
                  <div className="screensaver-feature-item">
                    <span className="screensaver-feature-dot"></span>
                    <span>Analytics Dashboard</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ScreensaversComp;